module.exports = __webpack_public_path__ + "img/boar.90a5d589.png";